// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DateFilters_filterButton__QwJNK {
  margin-top: 33px;
  align-self: baseline;
}

.DateFilters_close__kMP-l {
  position: absolute;
  z-index: 0;
  right: 35px;
  top: 13px;
}

.DateFilters_inputDisabled__c1nXU {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
          user-select: none;
}`, "",{"version":3,"sources":["webpack://./src/dashboard/components/DateFilters/DateFilters.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,oBAAA;AACF;;AAEA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;AACF;;AAEA;EACE,2BAAA;EACA,yBAAA;UAAA,iBAAA;AACF","sourcesContent":[".filterButton {\n  margin-top: 33px;\n  align-self: baseline;\n}\n\n.close {\n  position: absolute;\n  z-index: 0;\n  right: 35px;\n  top: 13px;\n}\n\n.inputDisabled {\n  -webkit-touch-callout: none;\n  user-select: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filterButton": `DateFilters_filterButton__QwJNK`,
	"close": `DateFilters_close__kMP-l`,
	"inputDisabled": `DateFilters_inputDisabled__c1nXU`
};
export default ___CSS_LOADER_EXPORT___;
